import type { ReactNode } from 'react'
import { ChevronLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import styles from './style.module.css'

interface PageHeaderProps {
  title: string
  subtitle?: ReactNode
  actions?: ReactNode
  backTo?: string
}

const PageHeader = ({ actions, backTo, subtitle, title }: PageHeaderProps) => {
  const navigate = useNavigate()

  return (
    <header className={styles.header}>
      <div className={styles.titleArea}>
        {backTo ? (
          <button
            type="button"
            className={styles.back}
            onClick={() => navigate(backTo)}
            aria-label="Voltar"
          >
            <ChevronLeft size={18} />
          </button>
        ) : null}

        <div>
          <h1 className={styles.title}>{title}</h1>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>
      </div>

      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  )
}

export default PageHeader
